<template>
  <div class="notification-table" data-testid="notification-table">
    <v-skeleton-loader
      v-if="loading"
      :type="skeletonType"
      width="100%"
      data-testid="notification-table__loading-skeleton"
    />
    <lb-datatablenew
      v-else-if="hasItems"
      data-testid="notification-table__data-table"
      :headers="headers"
      :items="items"
      :enableslot="slots"
      :loading="loading"
    >
    <template v-if="isSchedulersTab" v-slot:scheduler="{ item }">
      <div class="d-none" data-testid="notification-table__scheduler-hidden">{{ item }}</div>
      <span data-testid="notification-table__scheduler">24</span>
    </template>
    <template v-slot:statusvalue="{ item }">
      <StatusIndicator
        :variant="item.statusvalue === 'Enabled' ? 'active' : 'workflow-disabled'"
        :custom-label="item.statusvalue === 'Enabled' ? 'Enabled' : 'Disabled'"
        size="sm"
        data-testid="notification-table__status-row"
      />
    </template>
    <template v-slot:action="{ item }">
      <div class="d-flex align-center justify-center" data-testid="notification-table__actions-row">
        <v-tooltip bottom content-class="tooltip-bottom" v-if="isSchedulersTab" data-testid="notification-table__edit-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-btn data-testid="data-table-new__sort-btn-none" icon small 
              v-bind="attrs"
              v-on="on"
              class="grey--text text--lighten-1"  @click="$emit('edit', item)">
                <img  src="/img/icons/PenEditIcon.svg" alt="edit"  data-testid="notification-table__edit-icon"/>
              </v-btn>
          </template>
          <span data-testid="notification-table__edit-tooltip-text">Update</span>
        </v-tooltip>

        <div class="d-flex align-center justify-center" v-else>
          <v-switch
            :loading="loadingStatus && loadingItem === item"
            data-testid="notification-table__status-switch"
            v-model="item.enabledordisabled"
            inset
            class="mt-0 custom-switch"
            hide-details
            @change="handleStatusChange(item)"
          ></v-switch>
        </div>
      </div>
    </template>
    </lb-datatablenew>
    <div
      v-else
      class="text-center grey--text title pa-6"
      data-testid="notification-table__empty-state"
    >
      No data available
    </div>
  </div>
</template>

<script>
import { NOTIFICATIONS } from "../../utils/constants";
import StatusIndicator from '../StatusIndicator.vue';

export default {
  name: "NotificationTable",
  components: {
    StatusIndicator,
  },
  data() {
    return {
      loadingItem: null,
    };
  },
  computed: {
    hasItems() {
      return Array.isArray(this.items) && this.items.length > 0;
    },
    skeletonType() {
      return NOTIFICATIONS.LOADING_SKELETON_TYPES.TABLE;
    },
  },
  watch: {
    loadingStatus(val) {
      if (!val) {
        this.loadingItem = null;
      }
    },
  },
  methods: {
    /**
     * Handles the status change event from the switch.
     * Emits 'disableEnable' event with the item and the action ('enable' or 'disable').
     * @param {Object} item - The item being updated.
     */
    handleStatusChange(item) {
      this.loadingItem = item;
      const action = item.enabledordisabled ? 'enable' : 'disable';
      this.$emit('disableEnable', item, action);
    },
  },
  beforeDestroy() {
    this.loadingItem = null;
  },
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    slots: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isSchedulersTab: {
      type: Boolean,
      default: false,
    },
    loadingStatus: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>

</style>